/*
 * Copyright (c) 2021 CalAmp Corp.  All Rights Reserved
 */
import isEmpty from 'lodash.isempty';
import {createSelector} from 'reselect';
import {createDeepEqualSelector} from '@ion/applications/src/store/selectors/SelectorUtils';
import {Role} from '@ion/core/src/types/entities';
import {Page} from '@/types/pages';
import {selectGlobalGroupId} from './global-group-chooser-selectors';
import {selectUsername} from './login-selectors';
import {selectPages} from './nav-selectors';

// input selectors ...
const selectIsInitializing         = ({initialization}) => initialization.isInitializing;
const selectInitializationComplete = ({initialization}) => initialization.initializationComplete;
const selectIsFromPrime            = ({initialization}) => initialization.isFromPrime;
const selectInitialAccounts        = ({initialization: {accounts}}) => accounts;
const selectRole                   = ({initialization: {role}}) => role;
const selectIsReadOnlyUser         = ({initialization: {isReadOnlyUser}}) => isReadOnlyUser;

// output selectors ...
export const initialAccountsSelector = createDeepEqualSelector(selectInitialAccounts, (accounts) => accounts);

export const isInitializingSelector = createSelector(selectIsInitializing,
  (isInitializing: boolean): boolean => isInitializing
);

export const initializationCompleteSelector = createSelector(selectInitializationComplete,
  (initializationComplete: boolean): boolean => initializationComplete
);

export const isFromPrimeSelector = createSelector(selectIsFromPrime,
  (isFromPrime: boolean): boolean => isFromPrime
);

export const isReadOnlyUserSelector = createSelector(selectIsReadOnlyUser,
  (isReadOnlyUser: boolean): boolean => isReadOnlyUser
);

export const pageLoadSelector = createSelector([selectPages, selectUsername, selectGlobalGroupId],
  (pages: Page[], username: string, globalGroupId: number) =>
    Boolean(pages.length > 0 && !isEmpty(username) && globalGroupId)
);

export const roleSelector = createSelector(selectRole,
  (role: Role): Role => role
);
